import { types } from "@roo-dev/common";
import { useContactOwner } from "@Roo/api/vet/useContactOwner";
import { ReasonForRegistering } from "@Roo/constants/checkBoxConstants";
import { CalendlyPointOfEntry } from "@Roo/constants/posthogEventContextTypes";
import { UTM_SOURCE_EVENT } from "@Roo/EventSignUp/components/events/common/EventSignUpRedirectContainer";
import { HighCommitmentMeetYourRep } from "@Roo/RegistrationNew/Components/RegistrationMeetYourRooRep/SegmentedRegistration/HighCommitmentMeetYourRep";
import { LowCommitmentMeetYourRep } from "@Roo/RegistrationNew/Components/RegistrationMeetYourRooRep/SegmentedRegistration/LowCommitmentMeetYourRep";
import React, { useCallback, useEffect } from "react";
import { Event, EventTracker } from "../../../tracking/service/EventTracker/EventTrackerService";
import { useProgressPercentEffect } from "../Common/hooks/useProgressPercentEffect";
import { useRedirect } from "../Common/hooks/useRedirect";
import { useRegistrationContext } from "../Common/registrationContext";
import { REGISTRATION_PROGRESS_PERCENT } from "../Common/service";
import { RegistrationPageContainer } from "../RegistrationPageContainer/RegistrationPageContainer";

export const RegistrationMeetYourRooRep = () => {
  const {
    registrationContext: { entityId, utmSource, reasonForRegistering },
  } = useRegistrationContext();
  const { redirectToCalendly, redirectToVetPreferences } = useRedirect();
  useProgressPercentEffect(REGISTRATION_PROGRESS_PERCENT.MeetRooRep);

  const { data } = useContactOwner({ vetId: entityId });
  const { firstName, lastName, photo } = data?.data ?? {};

  const isHighCommitment = reasonForRegistering === ReasonForRegistering.FindingTheRightShift;

  const isFromEvent = utmSource === UTM_SOURCE_EVENT;
  const showBackButton = !isFromEvent;

  const sendEvent = useCallback(
    (event: types.EventName, eventType: types.EventType) => {
      EventTracker.send({
        eventName: event,
        eventType: eventType,
        entityType: Event.Entity.VET,
        entityId,
        context: { pointOfEntry: CalendlyPointOfEntry.RegistrationMeetYourRooRep },
      });
    },
    [entityId]
  );

  const handleScheduleCall = () => {
    sendEvent(Event.Name.VET_SCHEDULE_ACTIVATION_CALL_START, Event.Type.CLICK);

    redirectToCalendly({ shiftPreview: true });
  };

  useEffect(() => {
    if (entityId) {
      sendEvent(Event.Name.VET_VIEW_ACTIVATION_CALL, Event.Type.IMPRESSION);
    }
  }, [sendEvent, entityId]);

  return (
    <RegistrationPageContainer
      linkProps={
        showBackButton
          ? {
              children: "Back to Preferences",
              onClick: () => {
                redirectToVetPreferences({ highCommitment: isHighCommitment });
              },
            }
          : undefined
      }
    >
      {isHighCommitment ? (
        <HighCommitmentMeetYourRep
          handleScheduleCall={handleScheduleCall}
          firstName={firstName}
          lastName={lastName}
          photo={photo}
        />
      ) : (
        <LowCommitmentMeetYourRep handleScheduleCall={handleScheduleCall} />
      )}
    </RegistrationPageContainer>
  );
};
